<template>
  <div class="w-full">
    <cardTitle title="隐患治理情况" cardType='shimen'>
      <template  v-slot:extend>
        <div class="flex items-center">
          <div
            class="tab-item"
            :class="activeTabItem === 0 ? 'active-tab' : ''"
            @click="tabChange(0)"
          >
            周
          </div>
          <div
            class="tab-item"
            :class="activeTabItem === 1 ? 'active-tab' : ''"
            @click="tabChange(1)"
          >
            月
          </div>
          <div
            class="tab-item"
            :class="activeTabItem === 2 ? 'active-tab' : ''"
            @click="tabChange(2)"
          >
            年
          </div>
        </div>
      </template></cardTitle>

       <v-chart
        :options="hiddenDangerOptions"
        class="!h-[calc(100%-52px)] !w-full"
        :autoresize="true"
      ></v-chart>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import CockpitService from '../../service/index'

export default {
  name: '',
  props: [],
  components: { CardTitle },

  data() {
    return {
      activeTabItem: 0,
      tabChangeInterval: null,
      hiddenDangerOptions: {
        grid: {
          top: '15%',
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        legend: {
          left: 'center',
          top: '5',
          show: true,
          textStyle: {
            color: '#fff',
            padding: [2, 0, 0, 0],
          },
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(40, 48, 48, 0.3)',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 10,
          textStyle: {
            color: '#fff',
            align: 'left'
          },
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false },
          axisLabel: {
            show: true,
            interval: (i, v) => { return true }, // 避免最后一项文字加深
            margin: 15,
            color: '#fff90',
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: 'rgba(0, 0, 0, .5)',
            },
          },
          data: [],
        },
        yAxis: {
          name: '',
          nameLocation: 'start',
          nameGap: 10,
          nameTextStyle: {
            color: '#fff9',
            padding: [0, 0, 0, -30],
          },
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.6)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 12,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D9D9D919',
            },
          },
        },
        series: [
          {
            name: '新增数量',
            type: 'bar',
            stack: '数量',
            barWidth: 20,
            itemStyle: {
              normal: {
                // 这里是颜色
                color: '#409eff',
              },
            },
            data: [],
          },
          {
            name: '未完成整改数量',
            type: 'bar',
            stack: '数量',
            barWidth: 20,
            itemStyle: {
              normal: {
                // 这里是颜色
                color: '#F56C6C',
              },
            },
            data: [],
          },
        ],
      },
    }
  },
  methods: {
    async getHiddenDangerStatistics(type) {
      const [err, res] = await CockpitService.getHiddenDangerStatistics({
        type,
      })
      if (res && res.code === 0 && res.data) {
        this.hiddenDangerOptions.xAxis.data = _.map(res.data, 'name')
        this.hiddenDangerOptions.series[0].data = _.map(res.data, 'addCount')
        this.hiddenDangerOptions.series[1].data = _.map(
          res.data,
          'unfinishedCount'
        )
      }
      console.log(res)
    },
    async tabChange(type) {
      this.activeTabItem = type
      await this.getHiddenDangerStatistics(type)
    },
  },
  beforeDestroy() {
    clearInterval(this.tabChangeInterval)
  },
  mounted() {
    this.tabChange(0)
    this.tabChangeInterval = setInterval(() => {
      this.tabChange(this.activeTabItem)
    }, 5000)
  }
}
</script>

<style lang="scss" scoped>
.active-tab {
  color: #fff !important;
  background-color: #409eff;
}
.tab-item {
  text-align: center;
  line-height: 25px;
  margin-right: 10px;
  font-size: 14px !important;
  width: 25px;
  cursor: pointer;
  color: #d9d9d9;
}
</style>
